var map = {
	"./LVV/Appeal Handling-En.png": 4804,
	"./LVV/Appeal Handling-Id.png": 3306,
	"./LVV/Benefit/Access to Green Finance.png": 4196,
	"./LVV/Benefit/Cost Savings.png": 6506,
	"./LVV/Benefit/Government Incentives.png": 3167,
	"./LVV/Benefit/Transparency and Accountability.png": 8564,
	"./LVV/Complaint Handling-En.png": 856,
	"./LVV/Complaint Handling-Id.png": 3798,
	"./LVV/Services/GHG Validation and Verification for Project Level.png": 8762,
	"./LVV/Services/GHG Verification for Organization Level.png": 1118,
	"./LVV/Services/Other Services.png": 8583,
	"./LVV/Services/Service Methodology.png": 7873,
	"./LVV/appeal-fc.png": 1893,
	"./LVV/barcode.png": 6638,
	"./LVV/flow-vvb-En.png": 1813,
	"./LVV/flow-vvb-Id.png": 4587,
	"./LVV/flow-vvb-mobile-En.png": 1980,
	"./LVV/flow-vvb-mobile-Id.png": 3666,
	"./TKDN/Appeal Handling.png": 9279,
	"./TKDN/Appeal-Mobile-En.png": 3235,
	"./TKDN/Appeal-Mobile-Id.png": 101,
	"./TKDN/Appeal-Web-En.png": 4419,
	"./TKDN/Appeal-Web-Id.png": 4549,
	"./TKDN/Benefit/Create Investment Opportunities.png": 7219,
	"./TKDN/Benefit/Create Job Opportunities.png": 6077,
	"./TKDN/Benefit/Increase Domestic Industrial Sector.png": 3822,
	"./TKDN/Benefit/Increase Other Economic Sectors.png": 227,
	"./TKDN/Benefit/Increase Small Industry.png": 9454,
	"./TKDN/Benefit/Increase Tax Revenue.png": 1036,
	"./TKDN/Complaint Handling.png": 7665,
	"./TKDN/Complaint-Mobile-En.png": 6417,
	"./TKDN/Complaint-Mobile-Id.png": 2671,
	"./TKDN/Complaint-Web-En.png": 221,
	"./TKDN/Complaint-Web-Id.png": 4371,
	"./TKDN/Hero TKDN.png": 1510,
	"./TKDN/LCA Process-Mobile-En.png": 2505,
	"./TKDN/LCA Process-Mobile-Id.png": 4679,
	"./TKDN/LCA Process-Web-En.png": 7637,
	"./TKDN/LCA Process-Web-Id.png": 203,
	"./TKDN/LCA/Agricultural Machinery and Equipment.png": 1614,
	"./TKDN/LCA/Agricultural Supporting Materials.png": 1396,
	"./TKDN/LCA/Building Construction Materials.png": 6691,
	"./TKDN/LCA/Chemicals and Chemical Goods.png": 7746,
	"./TKDN/LCA/Clothing and Work Equipment.png": 660,
	"./TKDN/LCA/Computers and Office Equipment.png": 4483,
	"./TKDN/LCA/Defense Tools.png": 8199,
	"./TKDN/LCA/Electrical Equipment.png": 5142,
	"./TKDN/LCA/Electronic Equipment.png": 2570,
	"./TKDN/LCA/Factory Machinery and Equipment.png": 2491,
	"./TKDN/LCA/Heavy Equipment, Construction and Material Handling.png": 6321,
	"./TKDN/LCA/Laboratory Equipment.png": 1639,
	"./TKDN/LCA/Materials and Health Equipment.png": 357,
	"./TKDN/LCA/Metal and Metal Items.png": 46,
	"./TKDN/LCA/Mining Machinery and Equipment.png": 7751,
	"./TKDN/LCA/Oil and Gas Machinery and Equipment.png": 7449,
	"./TKDN/LCA/Other Goods.png": 9882,
	"./TKDN/LCA/Sports and Education Equipment.png": 5820,
	"./TKDN/LCA/Telecommunications Equipment.png": 3487,
	"./TKDN/LCA/Transportation.png": 4822,
	"./VPTI-1.png": 4346,
	"./VPTI-2.png": 1777,
	"./VPTI-3.png": 648,
	"./VPTI/Ace.png": 7247,
	"./VPTI/Acer.png": 5540,
	"./VPTI/Adiprima Suraprinta.png": 9847,
	"./VPTI/Aik Moh.png": 1008,
	"./VPTI/Ajinomoto.png": 253,
	"./VPTI/Akebono.png": 2423,
	"./VPTI/American Standard.png": 5220,
	"./VPTI/Apple.png": 5709,
	"./VPTI/Aqua Japan.png": 2421,
	"./VPTI/Asus.png": 9901,
	"./VPTI/BAP.png": 4,
	"./VPTI/BBW.png": 8982,
	"./VPTI/BSP.png": 398,
	"./VPTI/Baby Safe.png": 3786,
	"./VPTI/Beaba.png": 6958,
	"./VPTI/Bernadi Utama.png": 4646,
	"./VPTI/Bridgestone.png": 6223,
	"./VPTI/Bridon.png": 9853,
	"./VPTI/Brompton.png": 5666,
	"./VPTI/Calbee Wings.png": 2873,
	"./VPTI/Cannondale.png": 458,
	"./VPTI/Canon.png": 5340,
	"./VPTI/Chanel.png": 4406,
	"./VPTI/Chatime.png": 1156,
	"./VPTI/Cimory.png": 9998,
	"./VPTI/Cold Stone.png": 6564,
	"./VPTI/Colnago.png": 530,
	"./VPTI/Columbia.png": 9417,
	"./VPTI/Continental.png": 6238,
	"./VPTI/Daikin.png": 7881,
	"./VPTI/Dua kelinci.png": 2702,
	"./VPTI/ELC.png": 5335,
	"./VPTI/Eco Paper.png": 9364,
	"./VPTI/Emco.png": 7921,
	"./VPTI/Fitflop.png": 1971,
	"./VPTI/Freeport.png": 518,
	"./VPTI/Fujifilm.png": 8783,
	"./VPTI/Giordano.png": 6482,
	"./VPTI/Goldengres.png": 1921,
	"./VPTI/Goodyear.png": 7349,
	"./VPTI/Gree.png": 9524,
	"./VPTI/HSP.png": 8480,
	"./VPTI/Haniori.png": 795,
	"./VPTI/Herbalife.png": 6489,
	"./VPTI/Hermes.png": 4279,
	"./VPTI/Hisense.png": 6948,
	"./VPTI/Hp.png": 8225,
	"./VPTI/Hush Puppies.png": 9935,
	"./VPTI/Hyundai Motor.png": 6892,
	"./VPTI/IMCP.png": 5602,
	"./VPTI/ITTI.png": 1543,
	"./VPTI/Inan.png": 789,
	"./VPTI/Informa.png": 4161,
	"./VPTI/JUST MISS.png": 1807,
	"./VPTI/Jakarta Sereal.png": 5643,
	"./VPTI/Kkv.png": 3337,
	"./VPTI/Kobexindo.png": 5400,
	"./VPTI/Kohler.png": 8986,
	"./VPTI/Komatsu.png": 6469,
	"./VPTI/Krisbow.png": 3736,
	"./VPTI/LG.png": 3178,
	"./VPTI/LV.png": 7635,
	"./VPTI/Lava.png": 395,
	"./VPTI/Lavin Paris.png": 3384,
	"./VPTI/Lenovo.png": 2724,
	"./VPTI/Lixil.png": 7117,
	"./VPTI/Lock n Lock.png": 5365,
	"./VPTI/Longmarch.png": 1074,
	"./VPTI/Mamasuka.png": 5737,
	"./VPTI/Matsuo.png": 3084,
	"./VPTI/Maxxis.png": 6347,
	"./VPTI/Mercedes.png": 8037,
	"./VPTI/Mixue.png": 81,
	"./VPTI/Modena.png": 3403,
	"./VPTI/Mothercare .png": 2363,
	"./VPTI/Mothercare.png": 2787,
	"./VPTI/Nakshatra.png": 6974,
	"./VPTI/Oppo.png": 1855,
	"./VPTI/PT Mahugi.png": 3986,
	"./VPTI/PT Sukses Investa Anugrah Propertindo.png": 4241,
	"./VPTI/PT Trimulia Warnajaya.png": 7768,
	"./VPTI/Pacific.png": 3248,
	"./VPTI/Panasonic.png": 5659,
	"./VPTI/Petrokimia Gresik.png": 197,
	"./VPTI/Phillips.png": 5332,
	"./VPTI/Pirelli.png": 9486,
	"./VPTI/R&R Tech.png": 6303,
	"./VPTI/Ricoh.png": 8218,
	"./VPTI/Rolls-royce.png": 6336,
	"./VPTI/SSK.png": 9148,
	"./VPTI/Salomon.png": 3302,
	"./VPTI/Samsung.png": 9469,
	"./VPTI/Sarana Steel.png": 76,
	"./VPTI/Schlumberger.png": 8202,
	"./VPTI/Sharp.png": 9449,
	"./VPTI/Shiseido.png": 8337,
	"./VPTI/Specialized.png": 6978,
	"./VPTI/Starbucks.png": 9705,
	"./VPTI/Subur Anugerah Tangerang Java Indonesia.png": 3232,
	"./VPTI/Surly.png": 1978,
	"./VPTI/Tefal.png": 3435,
	"./VPTI/Texcoms.png": 2760,
	"./VPTI/The North Face.png": 6274,
	"./VPTI/Tica.png": 5808,
	"./VPTI/Tomica.png": 3159,
	"./VPTI/Torch Ceramics.png": 5324,
	"./VPTI/Toyo Tires.png": 5783,
	"./VPTI/Toyota Tsusho.png": 4267,
	"./VPTI/Triangle.png": 3937,
	"./VPTI/Under Armour.png": 4935,
	"./VPTI/Uniqlo.png": 8805,
	"./VPTI/United.png": 4288,
	"./VPTI/Vans.png": 9703,
	"./VPTI/Vivo.png": 4795,
	"./VPTI/Yokohama.png": 8608,
	"./VPTI/h&m.png": 8674,
	"./VPTI/oriflame.png": 9544,
	"./VPTI/sociolla.png": 4559,
	"./VPTI/the body shop.png": 7464,
	"./VPTI/victoria secret.png": 3132,
	"./aisi.png": 1789,
	"./alas-kaki.png": 2275,
	"./anindya-logo-footer.png": 3857,
	"./anindya-logo-white.png": 4917,
	"./anindya-logo.png": 9081,
	"./apbi-icma.png": 2400,
	"./astm.png": 3730,
	"./ban.png": 872,
	"./barang-modal-tidak-baru.png": 2429,
	"./barang-tekstil-sudah-jadi-lainnya.png": 9975,
	"./barang.png": 7106,
	"./bav.png": 9296,
	"./bawang-putih copy.png": 1927,
	"./bawang-putih.png": 1806,
	"./besi-baja.png": 2575,
	"./branches-map.png": 234,
	"./clients/Batubara/ABP.png": 968,
	"./clients/Batubara/Adani.png": 2284,
	"./clients/Batubara/BMB.png": 2656,
	"./clients/Batubara/BRE.png": 9418,
	"./clients/Batubara/BSSR.png": 5349,
	"./clients/Batubara/Borneo Indobara.png": 7698,
	"./clients/Batubara/Equentia.png": 5395,
	"./clients/Batubara/Jembayan.png": 5294,
	"./clients/Batubara/KJB.png": 4696,
	"./clients/Batubara/Kideco.png": 12,
	"./clients/Batubara/PKN.png": 3012,
	"./clients/Batubara/RLK.png": 9966,
	"./clients/Batubara/SGE.png": 7660,
	"./clients/Batubara/Tamtama.png": 4826,
	"./clients/Batubara/Titan.png": 8717,
	"./clients/Coal/ABP.png": 2951,
	"./clients/Coal/Adani.png": 6459,
	"./clients/Coal/BMB.png": 9731,
	"./clients/Coal/BRE.png": 6677,
	"./clients/Coal/BSSR.png": 9912,
	"./clients/Coal/Borneo Indobara.png": 6517,
	"./clients/Coal/Equentia.png": 1546,
	"./clients/Coal/Jembayan.png": 3023,
	"./clients/Coal/KJB.png": 687,
	"./clients/Coal/Kideco.png": 4605,
	"./clients/Coal/PKN.png": 6835,
	"./clients/Coal/RLK.png": 677,
	"./clients/Coal/SGE.png": 5891,
	"./clients/Coal/Tamtama.png": 5809,
	"./clients/Coal/Titan.png": 5510,
	"./clients/Marine/AKR.png": 4013,
	"./clients/Marine/Alexindo.png": 6793,
	"./clients/Marine/Cotecna.png": 7242,
	"./clients/Marine/DBS.png": 5222,
	"./clients/Marine/Duta Marine.png": 7249,
	"./clients/Marine/Figar.png": 2788,
	"./clients/Marine/HTK.png": 6816,
	"./clients/Marine/Holcim.png": 5145,
	"./clients/Marine/Indocement.png": 4585,
	"./clients/Marine/Lafarge.png": 9019,
	"./clients/Marine/MSD.png": 9519,
	"./clients/Marine/SBA.png": 8663,
	"./clients/Marine/SBI.png": 4623,
	"./clients/Marine/SIT.png": 2675,
	"./clients/Marine/SLM.png": 4181,
	"./clients/Marine/Seapol.png": 8285,
	"./clients/Marine/Trubaindo.png": 9141,
	"./clients/Marine/Victoria.png": 9992,
	"./clients/Marine/Watama.png": 5548,
	"./clients/Mineral & Air/BSI.png": 1833,
	"./clients/Mineral & Air/CLM.png": 5661,
	"./clients/Mineral & Air/GAG.png": 8764,
	"./clients/Mineral & Air/Hengjaya.png": 1582,
	"./clients/Mineral & Air/Ifishco.png": 3942,
	"./clients/Mineral & Air/Ranger.png": 8864,
	"./clients/Mineral & Air/SMI.png": 962,
	"./clients/Mineral & Air/TSI.png": 3531,
	"./clients/Mineral & Air/VDNI.png": 8010,
	"./clients/Mineral & Air/Walsin.png": 2353,
	"./clients/Mineral & Air/YII-2.png": 2317,
	"./clients/Mineral & Air/YII.png": 3688,
	"./clients/Mineral & Air/YNI.png": 4393,
	"./clients/Mineral & Water/BSI.png": 9388,
	"./clients/Mineral & Water/CLM.png": 2288,
	"./clients/Mineral & Water/GAG.png": 8925,
	"./clients/Mineral & Water/Hengjaya.png": 7777,
	"./clients/Mineral & Water/Ifishco.png": 2991,
	"./clients/Mineral & Water/Ranger.png": 4351,
	"./clients/Mineral & Water/SMI.png": 3659,
	"./clients/Mineral & Water/TSI.png": 2990,
	"./clients/Mineral & Water/VDNI.png": 781,
	"./clients/Mineral & Water/Walsin.png": 4762,
	"./clients/Mineral & Water/YII-2.png": 3936,
	"./clients/Mineral & Water/YII.png": 9473,
	"./clients/Mineral & Water/YNI.png": 3264,
	"./clients/Minyak & Gas/ABS.png": 9997,
	"./clients/Minyak & Gas/BNP.png": 2789,
	"./clients/Minyak & Gas/DCG.png": 1083,
	"./clients/Minyak & Gas/DSI.png": 2725,
	"./clients/Minyak & Gas/FJS.png": 5542,
	"./clients/Minyak & Gas/PC.png": 7570,
	"./clients/Minyak & Gas/RBN.png": 9511,
	"./clients/Oil & Gas/ABS.png": 4782,
	"./clients/Oil & Gas/BNP.png": 7142,
	"./clients/Oil & Gas/DCG.png": 6176,
	"./clients/Oil & Gas/DSI.png": 6910,
	"./clients/Oil & Gas/FJS.png": 1173,
	"./clients/Oil & Gas/PC.png": 6755,
	"./clients/Oil & Gas/RBN.png": 7532,
	"./clients/Survei Kapal Laut/AKR.png": 7848,
	"./clients/Survei Kapal Laut/Alexindo.png": 2558,
	"./clients/Survei Kapal Laut/Cotecna.png": 4263,
	"./clients/Survei Kapal Laut/DBS.png": 1431,
	"./clients/Survei Kapal Laut/Duta Marine.png": 2344,
	"./clients/Survei Kapal Laut/Figar.png": 409,
	"./clients/Survei Kapal Laut/HTK.png": 533,
	"./clients/Survei Kapal Laut/Holcim.png": 254,
	"./clients/Survei Kapal Laut/Indocement.png": 2606,
	"./clients/Survei Kapal Laut/Lafarge.png": 9934,
	"./clients/Survei Kapal Laut/MSD.png": 1674,
	"./clients/Survei Kapal Laut/SBA.png": 8318,
	"./clients/Survei Kapal Laut/SBI.png": 838,
	"./clients/Survei Kapal Laut/SIT.png": 1562,
	"./clients/Survei Kapal Laut/SLM.png": 6680,
	"./clients/Survei Kapal Laut/Seapol.png": 5922,
	"./clients/Survei Kapal Laut/Trubaindo.png": 188,
	"./clients/Survei Kapal Laut/Victoria.png": 9283,
	"./clients/Survei Kapal Laut/Watama.png": 5863,
	"./clients/VPTI/Aik Moh.png": 4327,
	"./clients/VPTI/Apple.png": 2542,
	"./clients/VPTI/Bridgestone.png": 5316,
	"./clients/VPTI/Brompton.png": 1187,
	"./clients/VPTI/Canon.png": 115,
	"./clients/VPTI/Cold Stone.png": 1093,
	"./clients/VPTI/ELC.png": 3068,
	"./clients/VPTI/Hermes.png": 9858,
	"./clients/VPTI/Hp.png": 1815,
	"./clients/VPTI/Kohler.png": 5507,
	"./clients/VPTI/Komatsu.png": 4462,
	"./clients/VPTI/LV.png": 1406,
	"./clients/VPTI/Matsuo.png": 2609,
	"./clients/VPTI/Mercedes.png": 3984,
	"./clients/VPTI/Panasonic.png": 5780,
	"./clients/VPTI/Samsung.png": 7326,
	"./clients/VPTI/Sharp.png": 3926,
	"./clients/VPTI/Starbucks.png": 4106,
	"./clients/VPTI/The North Face.png": 2407,
	"./clients/VPTI/Uniqlo.png": 1560,
	"./elektronika.png": 5112,
	"./flow-vpti.png": 1013,
	"./fosfa-international.png": 7823,
	"./gb.png": 9748,
	"./hero-banner-vpti.png": 6128,
	"./hero-banner.png": 1504,
	"./home-map.png": 2971,
	"./hortikultura.png": 8363,
	"./image-1.png": 7066,
	"./image-2.png": 6961,
	"./image-3.png": 4920,
	"./iso.png": 8252,
	"./jis.png": 1306,
	"./kaca-lembaran.png": 5170,
	"./kan.png": 9565,
	"./keramik.png": 6375,
	"./kosmetik.png": 2401,
	"./limbah-non-b3.png": 6752,
	"./mainan.png": 8857,
	"./makanan.png": 5158,
	"./marker.png": 5197,
	"./markered-maps.png": 4588,
	"./mesin.png": 5823,
	"./obat.png": 6603,
	"./pakaian-jadi copy.png": 5442,
	"./pakaian-jadi.png": 4333,
	"./pakaian.png": 7688,
	"./plastik.png": 9683,
	"./prekursor.png": 8810,
	"./sepeda.png": 3591,
	"./service-agri-id.png": 7134,
	"./service-agri.png": 930,
	"./service-coal-id.png": 9288,
	"./service-coal.png": 312,
	"./service-geo.png": 8058,
	"./service-marine-id.png": 6205,
	"./service-marine.png": 2496,
	"./service-mineral-id.png": 2689,
	"./service-mineral.png": 1327,
	"./service-non-metallic-id.png": 3268,
	"./service-non-metallic.png": 7836,
	"./service-oil-and-gas-id.png": 3263,
	"./service-oil-and-gas.png": 9105,
	"./service-vpti.png": 4866,
	"./services/Agriculture & Food-1.png": 9953,
	"./services/Agriculture & Food-2.png": 9370,
	"./services/Agriculture & Food-3.png": 4579,
	"./services/Batubara-1.png": 8776,
	"./services/Batubara-2.png": 1987,
	"./services/Batubara-3.png": 7882,
	"./services/Coal-1.png": 9455,
	"./services/Coal-2.png": 7988,
	"./services/Coal-3.png": 9117,
	"./services/Marine-1.png": 1940,
	"./services/Marine-2.png": 4399,
	"./services/Marine-3.png": 9302,
	"./services/Mineral & Air-1.png": 3236,
	"./services/Mineral & Air-2.png": 8511,
	"./services/Mineral & Air-3.png": 4710,
	"./services/Mineral & Water-1.png": 205,
	"./services/Mineral & Water-2.png": 8998,
	"./services/Mineral & Water-3.png": 8015,
	"./services/Mineral Non Logam-1.png": 6235,
	"./services/Mineral Non Logam-2.png": 1200,
	"./services/Mineral Non Logam-3.png": 2377,
	"./services/Minyak & Gas-1.png": 302,
	"./services/Minyak & Gas-2.png": 661,
	"./services/Minyak & Gas-3.png": 7772,
	"./services/Non-Metallic Minerals-1.png": 5070,
	"./services/Non-Metallic Minerals-2.png": 2901,
	"./services/Non-Metallic Minerals-3.png": 636,
	"./services/Oil & Gas-1.png": 1293,
	"./services/Oil & Gas-2.png": 7526,
	"./services/Oil & Gas-3.png": 2623,
	"./services/Pasir Kerikil & Pecahan Batu-1.png": 680,
	"./services/Pasir Kerikil & Pecahan Batu-2.png": 5171,
	"./services/Pasir Kerikil & Pecahan Batu-3.png": 6314,
	"./services/Pertanian & Makanan-1.png": 7597,
	"./services/Pertanian & Makanan-2.png": 6358,
	"./services/Pertanian & Makanan-3.png": 5375,
	"./services/Sand, Pebble & Crushed Stone-1.png": 4979,
	"./services/Sand, Pebble & Crushed Stone-2.png": 9224,
	"./services/Sand, Pebble & Crushed Stone-3.png": 6705,
	"./services/Survei Kapal Laut-1.png": 7469,
	"./services/Survei Kapal Laut-2.png": 9910,
	"./services/Survei Kapal Laut-3.png": 1455,
	"./services/VPTI-1.png": 8673,
	"./services/VPTI-2.png": 8506,
	"./services/VPTI-3.png": 6083,
	"./standards-australia.png": 912,
	"./tas copy.png": 7104,
	"./tas.png": 2967,
	"./tekstil copy.png": 2226,
	"./tekstil.png": 157,
	"./telepon.png": 5416,
	"./tuv-rheinland copy.png": 5857,
	"./tuv-rheinland.png": 9628,
	"./vpti-portrait.png": 6218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;